import React from "react";
import { TTableHeader } from "types/Components/Common/Table/Table"
import { Link } from "react-router-dom";

export const tableNameCallbackClassNames = (item: any) => {
    return (item.product_type as string)?.toLowerCase() === "individual" ? "!text-[#0747A6]" : undefined
}

export const DELTA_KEY = "delta_type"
export const PRODUCT_NAME_KEY = "name"
export const PRODUCT_TYPE_PARENT = "Parent"
export const PRODUCT_TYPE_PRODUCT = "Individual"
export const PRODUCT_TYPE_CHILD = "Child"

export const PLACEHOLDER_IMAGE = "https://cdn1.vectorstock.com/i/thumb-large/50/20/no-photo-or-blank-image-icon-loading-images-vector-37375020.jpg";

export const PRODUCT_TABLE_OPTIONS = {
    disableSort: true,
    height: "490px",
    selectable: true,
    striped: true,
    footer: true,
    image: (item: any) => item.image 
    // && JSON.parse(item.image)?.[0].JPEG_IMAGES?.default_image,
}
// product type component in delta table
export const ProductTypeComponentTable = ({item}: any) => {
   return (
        <div className={`tw-p-1 tw-rounded tw-px-2 tw-text-xs ${item.product_type === PRODUCT_TYPE_PRODUCT ? "tw-bg-[#E4D7FF] tw-text-[#3007A6]" : "tw-bg-[#DEEBFF] tw-text-[#0747A6]"} `}>
            {item.product_type ?? PRODUCT_TYPE_PRODUCT}
        </div>
   )
}

export const ProductNameComponentTable = ({item}: any) => {
    return (
         <div className={`${(item.product_type === PRODUCT_TYPE_PRODUCT || item.product_type === PRODUCT_TYPE_CHILD) ? "tw-text-[#0747A6]" : ""} tw-truncate tw-max-w-full tw-block tw-overflow-hidden`}>
            <Link to={item.product_type !== PRODUCT_TYPE_PARENT ? `/gms/product/details/${item.id}` : "#"}>
                {item.name}
            </Link>
         </div>
    )
 }

export const ProductDropdownComponent = ({product}: any) => {
    // if(product.product_type === PRODUCT_TYPE_CHILD || product.product_type === PRODUCT_TYPE_PRODUCT)
    //     return (
            
    //     )

    // return (

    // )
    return<></>
}

export const tableHeader: TTableHeader[] = [
    {
        name: "Products", 
        sortable: true, 
        column: "name", 
        options: { 
            callbackClassNames: tableNameCallbackClassNames, 
            width: "400px", 
            sticky: [true, {left: "48px"}],
            // callbackComponent: (item: any) => <ProductNameComponentTable item = {item}/>
        }
    },
    {name: "Version & Id", sortable: true, column: DELTA_KEY, options: {
        info: "Hover on Product type to view and copy Product UID",
    }},
    {name: "Type", sortable: true, column: "product_type", options: { 
        callbackComponent: (item: any) => <ProductTypeComponentTable item = {item}/> ,
    }},
    {name: "Created", sortable: true, column: "created_at"},
]

export const accordianTableHeader: TTableHeader[] = [
    {
        name: "variant  Name", 
        column: "name", 
        options: { 
            width: "396px", 
            sticky: [true, {left: "48px"}],
            callbackClassNames: tableNameCallbackClassNames, 
            callbackComponent: (item: any) => <ProductNameComponentTable item = {item}/>
        }
    },
    {name: "ID", column: DELTA_KEY},
    {name: "Type", column: "product_type", options: { callbackComponent: (item: any) => <ProductTypeComponentTable item = {item}/> }},
    // {name: "variant", column: "variant_count"},
    // {name: "Brand", column: "brand"},
    // {name: "Created", column: "created_at"},
]

export const SORT = {
    SEPERATE_ASC: "s_asc",
    SEPERATE_DESC: "s_desc",
    ASC: "asc",
    DESC: "desc"
}